export default __webpack_public_path__ + "static/media/img_baseCrochetRattle_grey.92f2857c.jpg";